import { motion } from "framer-motion";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";

const faqs = [
    {
        q: "Apa itu PUSATCUAN?",
        a: "PUSATCUAN adalah pusat layanan bantuan pelanggan yang siap melayani Anda 24 jam nonstop melalui WhatsApp dan Telegram resmi. Tim customer service kami responsif, aman, dan siap membantu kendala Anda kapan saja.",
    },
    {
        q: "Bagaimana cara menghubungi bantuan PUSATCUAN via WhatsApp?",
        a: "Anda dapat menghubungi PUSATCUAN WhatsApp resmi di nomor +855 96 4453 740 atau klik tombol Chat WhatsApp Pusatcuan di halaman ini. Layanan aktif 24 jam nonstop, tanpa libur.",
    },
    {
        q: "Apakah PUSATCUAN Telegram resmi tersedia 24 jam?",
        a: "Ya. PUSATCUAN Telegram resmi tersedia di ID @tpusatcuan. Admin kami siap merespons pesan Anda 24 jam nonstop setiap hari sebagai jalur pesan alternatif.",
    },
    {
        q: "Berapa nomor WhatsApp resmi PUSATCUAN?",
        a: "Nomor WhatsApp resmi PUSATCUAN adalah +855 96 4453 740. Pastikan Anda hanya menghubungi nomor resmi ini untuk keamanan akun dan data Anda.",
    },
    {
        q: "Apakah layanan pusatcuan chat aman?",
        a: "Sangat aman. Semua percakapan pusatcuan chat melalui WhatsApp dan Telegram resmi dienkripsi end-to-end oleh platform. Jangan pernah membagikan kode OTP atau kata sandi kepada siapa pun, termasuk pihak yang mengaku sebagai admin.",
    },
    {
        q: "Kapan saya bisa menggunakan layanan bantuan PUSATCUAN?",
        a: "Kapan saja. Bantuan PUSATCUAN beroperasi 24 jam nonstop, 7 hari seminggu, termasuk hari libur nasional. Tim kami selalu siaga melayani kendala Anda.",
    },
];

export const FAQ = () => (
    <section
        id="faq"
        data-testid="faq-section"
        className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32"
    >
        <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="mb-4 text-xs font-medium tracking-[0.3em] uppercase text-[#D4AF37]"
        >
            Pertanyaan Umum
        </motion.p>
        <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-serif-display mb-14 max-w-2xl text-3xl font-medium tracking-tight text-white sm:text-5xl"
        >
            Semua yang perlu Anda ketahui tentang bantuan PUSATCUAN.
        </motion.h2>

        <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
        >
            <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, i) => (
                    <AccordionItem
                        key={i}
                        value={`faq-${i}`}
                        data-testid={`faq-accordion-item-${i}`}
                        className="border-b border-[#D4AF37]/15"
                    >
                        <AccordionTrigger
                            data-testid={`faq-trigger-${i}`}
                            className="py-6 text-left font-serif-display text-lg font-medium text-white transition-colors duration-300 hover:text-[#F3E5AB] hover:no-underline sm:text-xl [&[data-state=open]]:text-[#D4AF37]"
                        >
                            {faq.q}
                        </AccordionTrigger>
                        <AccordionContent className="max-w-3xl pb-6 text-sm leading-relaxed text-[#A1A1AA] md:text-base">
                            {faq.a}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </motion.div>
    </section>
);
